<template>
  <div>
    <h1 class="title">PANTALLA {{ numeroPantalla }} ACCION MANUAL</h1>
    <HmiPantalla>
      <div class="content">
        <div class="screen-title">
          <HmiLabel label="ACCION MANUAL" width="100%" height="100%" :size="4" color="cyan" border="solid 6px yellow">
          </HmiLabel>
        </div>
        <div class="grid">
          <div class="custom-row">
            <HmiButton label="MANUAL VALVULA" width="25%" height="100%" :size="1.7" :color="manualValvula == '1'
              ? 'yellow'
              : 'silver'"
              @click.native="escrituraAlternaIR(direccionVariablesBit.MANUAL_VALVULA_ESCRITURA, manualValvula)">
            </HmiButton>
            <div class="column">
              <HmiLabel label="R.P.M. GENERADOR" width="100%" height="50%" :size="1.7" color="cyan">
              </HmiLabel>
              <HmiLabel :label="rpmGenerador" width="100%" height="50%" :size="2" color="silver"></HmiLabel>
            </div>
            <div class="column">
              <HmiLabel label="KW.ACT." width="100%" height="50%" :size="1.7" color="cyan"></HmiLabel>
              <HmiLabel :label="formatokw(kwActuales)" width="100%" height="50%" :size="2" color="silver">
              </HmiLabel>
            </div>
            <HmiButton label="MANUAL PALAS" width="25%" height="100%" :size="1.7" :color="manualPalas == '1'
              ? 'yellow'
              : 'silver'"
              @click.native="escrituraAlternaIR(direccionVariablesBit.MANUAL_PALAS_ESCRITURA, manualPalas)">
            </HmiButton>
          </div>
          <div class="custom-row">
            <HmiLabel label="VALVULA CERRADA" width="25%" height="100%" :size="1.7" :color="valvulaCerrada == '1'
              ? 'yellow'
              : '#C0FFFF'">
            </HmiLabel>
            <HmiButton label="CERRAR" width="25%" height="100%" :size="1.7" :color="cerrarValvula == '1'
              ? 'yellow'
              : 'silver'"
              @touchstart.native.prevent="escrituraMomentaneaIR(direccionVariablesBit.CERRAR_VALVULA_ESCRITURA, '1')"
              @touchend.native.prevent="escrituraMomentaneaIR(direccionVariablesBit.CERRAR_VALVULA_ESCRITURA, '0')"
              @mousedown.native="escrituraMomentaneaIR(direccionVariablesBit.CERRAR_VALVULA_ESCRITURA, '1')"
              @mouseup.native="escrituraMomentaneaIR(direccionVariablesBit.CERRAR_VALVULA_ESCRITURA, '0')">
            </HmiButton>
            <HmiLabel label="PALAS MAXIMO" width="25%" height="100%" :size="1.7" :color="palasMaximo == '1'
              ? 'yellow'
              : '#C0FFFF'"></HmiLabel>
            <HmiButton label="ABRIR" width="25%" height="100%" :size="1.7" :color="abrirPalas == '1'
              ? 'yellow'
              : 'silver'" 
              @touchstart.native.prevent="escrituraMomentaneaIR(direccionVariablesBit.ABRIR_PALAS_ESCRITURA, '1')"
              @touchend.native.prevent="escrituraMomentaneaIR(direccionVariablesBit.ABRIR_PALAS_ESCRITURA, '0')"
              @mousedown.native="escrituraMomentaneaIR(direccionVariablesBit.ABRIR_PALAS_ESCRITURA, '1')"
              @mouseup.native="escrituraMomentaneaIR(direccionVariablesBit.ABRIR_PALAS_ESCRITURA, '0')">
            </HmiButton>
          </div>
          <div class="custom-row">
            <HmiLabel label="VACIO OK" width="25%" height="100%" :size="1.7" :color="vacioOk == '1'
              ? 'yellow'
              : '#C0FFFF'"></HmiLabel>
            <HmiButton label="VACIO" width="25%" height="100%" :size="1.7" :color="activarValvulaVacio == '1'
              ? 'yellow'
              : 'silver'"
              @click.native="escrituraAlternaIR(direccionVariablesBit.ACTIVAR_VALVULA_VACIO_ESCRITURA, activarValvulaVacio)">
            </HmiButton>
            <HmiButton label="PRUEBA LAMPARAS" width="25%" height="100%" :size="1.7" :color="pruebaLamparas == '1'
              ? 'yellow'
              : 'silver'"
              @touchstart.native.prevent="escrituraMomentaneaIR(direccionVariablesBit.PRUEBA_LAMPARAS_ESCRITURA, '1')"
              @touchend.native.prevent="escrituraMomentaneaIR(direccionVariablesBit.PRUEBA_LAMPARAS_ESCRITURA, '0')"
              @mousedown.native="escrituraMomentaneaIR(direccionVariablesBit.PRUEBA_LAMPARAS_ESCRITURA, '1')"
              @mouseup.native="escrituraMomentaneaIR(direccionVariablesBit.PRUEBA_LAMPARAS_ESCRITURA, '0')">
            </HmiButton>
            <HmiButton label="CERRAR" width="25%" height="100%" :size="1.7" :color="cerrarPalas == '1'
              ? 'yellow'
              : 'silver'" 
              @touchstart.native.prevent="escrituraMomentaneaIR(direccionVariablesBit.CERRAR_PALAS_ESCRITURA, '1')"
              @touchend.native.prevent="escrituraMomentaneaIR(direccionVariablesBit.CERRAR_PALAS_ESCRITURA, '0')"
              @mousedown.native="escrituraMomentaneaIR(direccionVariablesBit.CERRAR_PALAS_ESCRITURA, '1')"
              @mouseup.native="escrituraMomentaneaIR(direccionVariablesBit.CERRAR_PALAS_ESCRITURA, '0')">
            </HmiButton>
          </div>
          <div class="custom-row">
            <div style="width: 25%"></div>
            <HmiLabel label="APERTURA PALAS" width="25%" height="100%" :size="1.7" color="cyan"></HmiLabel>
            <HmiLabel :label="formatoApertura(aperturaPlacas) + '%'" width="25%" height="100%" :size="1.7"
              color="#FF00C0"></HmiLabel>
            <HmiButton label="SALIR" width="25%" height="100%" :size="1.7" color="silver" @click.native="navigateToMenu">
            </HmiButton>
          </div>
        </div>
      </div>
    </HmiPantalla>
  </div>
</template>

<script>
import HmiButton from "../HMI/HmiButton.vue";
import HmiLabel from "../HMI/HmiLabel.vue";
import HmiPantalla from "../HMI/HmiPantalla.vue";
export default {
  name: "ManualPantalla",
  components: {
    HmiButton,
    HmiLabel,
    HmiPantalla,
  },
  computed: {
    // Obtenemos el numero de pantalla en la que estamos trabajandos
    numeroPantalla() {
      return this.$route.params.numeroPantalla;
    },

    direccionVariables() {
      if (this.numeroPantalla == 1) {
        return {
          RPM_GENERADOR_LECTURA: 0,
          KW_ACTUALES_1_LECTURA: 81,
          KW_ACTUALES_2_LECTURA: 82,
          APERTURA_PLACAS_LECTURA: 38,
        };
      } else {
        return {
          RPM_GENERADOR_LECTURA: 46,
          KW_ACTUALES_1_LECTURA: 100,
          KW_ACTUALES_2_LECTURA: 101,
          APERTURA_PLACAS_LECTURA: 39,
        };
      }
    },

    direccionVariablesBit() {
      if (this.numeroPantalla == 1) {
        return {
          // Correspondiente a 28.0 DM3140.0 Gen 1: Manual valvula
          MANUAL_VALVULA_LECTURA: [140, 0],
          MANUAL_VALVULA_ESCRITURA: ["Ir0028", 0],
          // Correspondiente a 28.03 DM3140.1 Gen 1: Manual palas
          MANUAL_PALAS_LECTURA: [140, 1],
          MANUAL_PALAS_ESCRITURA: ["Ir0028", 3],
          // Correspondiente a 1.04 DM3140.2 Gen 1: Valvula cerrada
          VALVULA_CERRADA_LECTURA: [140, 2],
          VALVULA_CERRADA_ESCRITURA: ["Ir0001", 4],
          // Correspondiente a 28.01 DM3140.3 Gen 1: Cerrar valvula
          CERRAR_VALVULA_LECTURA: [140, 3],
          CERRAR_VALVULA_ESCRITURA: ["Ir0028", 1],
          // Correspondiente a 1.06 DM3140.4 Gen 1: Vacio OK
          VACIO_OK_LECTURA: [140, 4],
          VACIO_OK_ESCRITURA: ["Ir0001", 6],
          // Correspondiente a 28.02 DM3140.5 Gen 1: Activar valvula vacio
          ACTIVAR_VALVULA_VACIO_LECTURA: [140, 5],
          ACTIVAR_VALVULA_VACIO_ESCRITURA: ["Ir0028", 2],
          // Correspondiente a 1.05 DM3140.6 Gen 1: Palas Maximo
          PALAS_MAXIMO_LECTURA: [140, 6],
          PALAS_MAXIMO_ESCRITURA: ["Ir0001", 5],
          // Correspondiente a 28.04 DM3140.7 Gen 1: Abrir palas
          ABRIR_PALAS_LECTURA: [140, 7],
          ABRIR_PALAS_ESCRITURA: ["Ir0028", 4],
          // Correspondiente a 28.05 DM3140.8 Gen 1: Cerrar palas
          CERRAR_PALAS_LECTURA: [140, 8],
          CERRAR_PALAS_ESCRITURA: ["Ir0028", 5],
          // Correspondiente a 102.03 DM3140.9 Gen 1: Prueba lamparas
          PRUEBA_LAMPARAS_LECTURA: [140, 9],
          PRUEBA_LAMPARAS_ESCRITURA: ["Ir0102", 3],
        };
      } else {
        return {
          // Correspondiente a 29.0 Dm3141.0 Gen 2: Manual valvula
          MANUAL_VALVULA_LECTURA: [141, 0],
          MANUAL_VALVULA_ESCRITURA: ["Ir0029", 0],
          // Correspondiente a 29.03 Dm3141.1 Gen 2: Manual palas
          MANUAL_PALAS_LECTURA: [141, 1],
          MANUAL_PALAS_ESCRITURA: ["Ir0029", 3],
          // Correspondiente a 3.04 Dm3141.2 Gen 2: Valvula cerrada
          VALVULA_CERRADA_LECTURA: [141, 2],
          VALVULA_CERRADA_ESCRITURA: ["Ir0003", 4],
          // Correspondiente a 29.01 Dm3141.3 Gen 2: Cerrar valvula
          CERRAR_VALVULA_LECTURA: [141, 3],
          CERRAR_VALVULA_ESCRITURA: ["Ir0029", 1],
          // Correspondiente a 3.06 Dm3141.4 Gen 2: Vacio OK
          VACIO_OK_LECTURA: [141, 4],
          VACIO_OK_ESCRITURA: ["Ir0003", 6],
          // Correspondiente a 29.02 Dm3141.5 Gen 2: Activar valvula vacio
          ACTIVAR_VALVULA_VACIO_LECTURA: [141, 5],
          ACTIVAR_VALVULA_VACIO_ESCRITURA: ["Ir0029", 2],
          // Correspondiente a 3.05 Dm3141.6 Gen 2: Palas Maximo
          PALAS_MAXIMO_LECTURA: [141, 6],
          PALAS_MAXIMO_ESCRITURA: ["Ir0003", 5],
          // Correspondiente a 29.04 Dm3141.7 Gen 2: Abrir palas
          ABRIR_PALAS_LECTURA: [141, 7],
          ABRIR_PALAS_ESCRITURA: ["Ir0029", 4],
          // Correspondiente a 29.05 Dm3141.8 Gen 2: Cerrar palas
          CERRAR_PALAS_LECTURA: [141, 8],
          CERRAR_PALAS_ESCRITURA: ["Ir0029", 5],
          // Correspondiente a 102.03 DM3140.9 Gen 1: Prueba lamparas
          PRUEBA_LAMPARAS_LECTURA: [140, 9],
          PRUEBA_LAMPARAS_ESCRITURA: ["Ir0102", 3],
        };
      }
    },

    rpmGenerador() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.RPM_GENERADOR_LECTURA
        ];
      }
      return "0000";
    },

    kwActuales() {
      if (this.direccionVariables) {
        return (
          this.$store.state.lecturas[
          this.direccionVariables.KW_ACTUALES_2_LECTURA
          ] +
          this.$store.state.lecturas[
          this.direccionVariables.KW_ACTUALES_1_LECTURA
          ]
        );
      }
      return "00000000";
    },

    aperturaPlacas() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.APERTURA_PLACAS_LECTURA
        ];
      }
      return "0000";
    },

    manualValvula() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.MANUAL_VALVULA_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.MANUAL_VALVULA_LECTURA[1]
        );
      }
      return "0";
    },

    manualPalas() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.MANUAL_PALAS_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.MANUAL_PALAS_LECTURA[1]
        );
      }
      return "0";
    },

    valvulaCerrada() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.VALVULA_CERRADA_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.VALVULA_CERRADA_LECTURA[1]
        );
      }
      return "0";
    },

    cerrarValvula() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.CERRAR_VALVULA_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.CERRAR_VALVULA_LECTURA[1]
        );
      }
      return "0";
    },

    vacioOk() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.VACIO_OK_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.VACIO_OK_LECTURA[1]
        );
      }
      return "0";
    },

    activarValvulaVacio() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.ACTIVAR_VALVULA_VACIO_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.ACTIVAR_VALVULA_VACIO_LECTURA[1]
        );
      }
      return "0";
    },

    palasMaximo() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.PALAS_MAXIMO_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.PALAS_MAXIMO_LECTURA[1]
        );
      }
      return "0";
    },

    abrirPalas() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.ABRIR_PALAS_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.ABRIR_PALAS_LECTURA[1]
        );
      }
      return "0";
    },

    cerrarPalas() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.CERRAR_PALAS_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.CERRAR_PALAS_LECTURA[1]
        );
      }
      return "0";
    },

    pruebaLamparas() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.PRUEBA_LAMPARAS_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.PRUEBA_LAMPARAS_LECTURA[1]
        );
      }
      return "0";
    },
  },

  mounted() {
    //Mandar a nodered entrada
    this.mandarEntrada();
    //Cuando se cierre la ventana enviar señal
    window.addEventListener("unload", this.mandarSalida);
  },
  destroyed() {
    //Mandar a nodered salida
    this.mandarSalida();
  },
  methods: {
    // Navegación a "Menu"
    navigateToMenu() {
      this.$router.push(`/pantalla/${this.numeroPantalla}`);
    },

    // Emitir evento salida
    mandarSalida() {
      this.$emit("mandar-pagina", "pagina/salida", "3", this.numeroPantalla);
    },

    // Emitir evento entrada
    mandarEntrada() {
      this.$emit("mandar-pagina", "pagina/entrada", "3", this.numeroPantalla);
    },

    formato2canales(dato) {
      return dato.substring(5, 8);
    },
    formatokw(dato){
      const numeroSinCeros = parseInt(dato)
      return (numeroSinCeros/1000).toString()
    },

    formatoApertura(dato) {
      dato = dato.substring(1, 4);
      return dato;
    },

    //Obtener bit
    obtenerBit(dato, posicion) {
      let intValue = parseInt(dato, 16);

      let binaryString = intValue.toString(2).padStart(16, "0");

      let bit = binaryString.charAt(binaryString.length - 1 - posicion);
      return bit;
    },

    escrituraAlternaIR(direccionEscritura, valor) {
      // Determinar la dirección y el número de bit desde direccionEscritura
      let direccion = direccionEscritura[0].substring(2);
      let bit = direccionEscritura[1];

      const nuevoValor = valor == "0" ? "1" : "0";

      const payload = {
        name: "escrituraIR",
        direccion: direccion,
        valor: nuevoValor,
        bit: bit,
      };

      // Emitir el nuevo payload
      this.$emit("mandar-escritura", payload);
    },

    escrituraMomentaneaIR(direccionEscritura, valor) {
      // Determinar la dirección y el número de bit desde direccionEscritura
      let direccion = direccionEscritura[0].substring(2);
      let bit = direccionEscritura[1];

      // Construir el payload 
      const payload = {
        name: "escrituraIR",
        direccion: direccion,
        valor: valor,
        bit: bit
      };
      // Emitir el nuevo payload
      this.$emit("mandar-escritura", payload);
    },
  },
};
</script>

<style scoped>
.title {
  font-family: "Courier New", Courier, monospace !important;
  text-align: center;
  margin: 20px 20px 0px 20px;
}

.content {
  height: 100%;
}

.screen-title {
  display: flex;
  justify-content: center;
  height: 15%;
}

.grid {
  height: 85%;
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  gap: clamp(1px, 5vw - 5px, 20px);
}

.custom-row {
  height: 25%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: clamp(1px, 5vw - 20px, 20px);
}

.column {
  display: flex;
  flex-direction: column;
  width: 25%;
  height: 100%;
  gap: 1px;
}
</style>
